import moment from 'moment';
import React from 'react';
import { translate } from 'react-i18next';
import { StyleSheet, Text, View } from 'react-native';
import Theme from '../../theme';
import { defaultScale } from '../../utils/scaling';
import { isMobile } from '../../utils/ScreenSizes';
import MealDetailMacros from './MealDetailMacros';

type PlaceholderTypeWhenConvertedToTsx = any;

interface IProps {
  day: PlaceholderTypeWhenConvertedToTsx;
  dayCals: number;
  dayCarbs: number;
  dayFat: number;
  dayProtein: number;
  t(key: string): string;
}

class DayFooter extends React.Component<IProps> {
  public render() {
    const { t } = this.props;
    const {
      dayCals, dayCarbs, dayFat, dayProtein, day,
    } = this.props;
    const dayOfWeek = moment().isSame(day.date, 'day') ? t('today') : moment(day.date).format('ddd');
    const dateWithoutYear = moment(day.date).format('DD MMM');

    return (
      <View style={styles.container}>
        <View style={[styles.dayMealCountItem, { width: '20%' }]}>
          <Text style={styles.countNum}>{dayOfWeek}</Text>
          <Text style={styles.textStyle}>{dateWithoutYear}</Text>
        </View>
        <MealDetailMacros
          meal={{
            calories: dayCals, carbs: dayCarbs, fat: dayFat, protein: dayProtein,
          }}
          customMainContainerStyle={styles.nutritionalInfo}
          layoutStyle='days'
        />
      </View>
    );
  }
}

const styles = StyleSheet.create({
  container: {
    borderRadius: 2,
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    paddingVertical: defaultScale(10),
    marginHorizontal: defaultScale(10),
    justifyContent: 'center',
    ...(isMobile() ? {} : { flex: 1 }),
  },
  dayMealCountItem: {
    flex: 1,
    paddingLeft: defaultScale(9),
    marginLeft: 5,
  },
  nutritionalInfo: {
    paddingVertical: defaultScale(0),
    paddingLeft: defaultScale(16), // push away from day of week
    paddingRight: defaultScale(4), // decrease overall item size
  },
  countNum: {
    ...Theme.textStyle.bodyCopyBold,
    color: Theme.DARK_CHARCOAL,
  },
  textStyle: {
    ...Theme.textStyle.small,
    color: Theme.DARK_CHARCOAL,
  },
});

export default translate(['nutrition'], { wait: true })(DayFooter);
